import { Component } from '@theme/component';

/**
 * Shop By Industry component
 *
 * Hovering/focusing a row in the right-hand list crossfades the left media
 * panel to that industry's image and marks the row as active. The last
 * hovered row stays active on mouseleave (no auto-clear) per design.
 *
 * @typedef {Object} Refs
 * @property {HTMLElement[]} rows
 * @property {HTMLElement[]} images
 *
 * @extends {Component<Refs>}
 */
class ShopByIndustryComponent extends Component {
  requiredRefs = ['rows', 'images'];

  /**
   * @param {string} index
   */
  select(index) {
    const targetIndex = Number(index);
    const { rows, images } = this.refs;
    if (targetIndex < 0 || targetIndex >= rows.length) return;

    for (const [i, row] of rows.entries()) {
      row.setAttribute('aria-current', String(i === targetIndex));
    }

    for (const [i, image] of images.entries()) {
      image.toggleAttribute('inert', i !== targetIndex);
    }
  }
}

if (!customElements.get('shop-by-industry-component')) {
  customElements.define('shop-by-industry-component', ShopByIndustryComponent);
}
